exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reviews-list-title[data-v-62120d94]{font-weight:700;padding-bottom:10px;padding-top:20px}", ""]);

// exports
